var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_629_620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60H0ZM60 60H0H60ZM0 60V0V60ZM40 0C56.5685 0 70 13.4315 70 30C70 46.5685 56.5685 60 40 60H30C41.0457 60 50 46.5685 50 30C50 13.4315 41.0457 0 30 0H40Z",
    fill: "#FBE11A",
    mask: "url(#path-1-inside-1_629_620)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMoon);
export default __webpack_public_path__ + "static/media/yellowMoon.af5e0ccfa7b7a68c1f9dd1e05f690c29.svg";
export { ForwardRef as ReactComponent };